export { default } from './ScrollToTop'
